export const ASSIGNEE_TYPES = {
  user: "user",
  group: "user-group"
};

export const formatAssignee = (assignee) => {
  switch (assignee.type) {
    case ASSIGNEE_TYPES.user:
      return `${assignee.lastName}, ${assignee.firstName}`;
    case ASSIGNEE_TYPES.group:
      return assignee.name;
    default:
      return `${assignee.lastName}, ${assignee.firstName}`;
  }
};
